import { Component } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { LoadingController, ModalController, ToastController } from '@ionic/angular';
import { DocumentService } from '../../services/document.service';
import { DataService } from '../../services/data.service';
import { Forms } from '../../utils/forms';

@Component({
  selector: 'app-upload-document-archive-modal',
  templateUrl: './upload-document-archive-modal.component.html',
  styleUrls: ['./upload-document-archive-modal.component.scss'],
  imports: [
    ReactiveFormsModule
  ],
  standalone: true
})
export class UploadDocumentArchiveModalComponent {
  uploadForm = new FormGroup({
    file: new FormControl(null, [Validators.required])
  })

  constructor(
    private modalCtrl: ModalController,
    private loadingCtrl: LoadingController,
    private documentService: DocumentService,
    private toastCtrl: ToastController,
    private dataService: DataService,
  ) { }

  close() {
    this.modalCtrl.dismiss();
  }

  async upload() {
    if (!this.uploadForm.valid) {
      this.uploadForm.markAllAsTouched();
      return;
    }

    // Upload the archive
    const enterprise = this.dataService.selectedEnterprise.value;
    const loading = await this.loadingCtrl.create();
    await loading.present();
    this.documentService.uploadArchive(this.uploadForm.value.file, enterprise).then(async () => {
      await loading.dismiss();
      this.close();
      this.toastCtrl.create({
        message: 'L\'archive a bien été mise en ligne.',
        color: 'success',
        position: 'bottom',
        header: 'Archive mise en ligne',
      });
    }).catch(async (res) => {
      await loading.dismiss();
      this.toastCtrl.create({
        message: 'Une erreur est survenue lors de l\'envoi de l\'archive.',
        color: 'danger',
        position: 'bottom',
        header: 'Erreur',
      });
    });
  }

  async loadFile($event: any | { target: { files: FileList } }) {
    // Convert the file to base64 and set it as value
    const files = $event.target.files;
    if (files.length > 0) {
      await Forms.inputToBase64(files[0]).then((res) => {
        this.uploadForm.controls['file'].setValue(res);
      });
    }
  }
}
